export default "__VITE_ASSET__Beq7oExw__"